<template>
    <LayoutsSectionRegularTemplate class="mt-16">
        <template #title >
            <span v-html="dataLocale.data.title"></span>
        </template>
        <template #content>
            <div class="embla" ref="emblaNode">
                <div class="embla__container">
                    <div class="embla__slide" v-for="agency in agencies">
                        <nuxt-img loading="lazy" :src="'/agency/' + agency" format="webp" :width="184" class="embla__slide__img"
                            :alt="'logo-' + agency.replace('.png', '').toLowerCase() + '-company'" />
                    </div>
                </div>
            </div>
        </template>
    </LayoutsSectionRegularTemplate>
</template>
<script lang="ts" setup>
import EmblaCarousel from 'embla-carousel-vue';
import DataLocale from '~~/config/interface/DataLocale';

const dataLocale = new DataLocale([
    {
        locale: "en",
        title: ' Join over <span class="down-mark-line"> 1,000,000 </span> Worldwide Users'
    },
    {
        locale: "vi",
        "title": 'Gia nhập hơn <span class="down-mark-line">1.000.000</span> người dùng trên toàn thế giới'
    },
    {
        locale: "es",
        "title": 'Únete a más de <span class="down-mark-line">1,000,000</span> usuarios en todo el mundo'
    },
    {
        locale: "de",
        "title": "Machen Sie bei über <span class=\"down-mark-line\">1.000.000</span> Nutzern weltweit mit"
    },
    {
        locale: "fr",
        title: 'Rejoignez plus de <span class="down-mark-line">1 000 000</span> utilisateurs dans le monde entier'
    },
    {
        locale: "it",
        title: 'Unisciti a oltre <span class="down-mark-line">1.000.000</span> utenti in tutto il mondo'
    },
    {
        locale: "nl",
        title: 'Sluit je aan bij meer dan <span class="down-mark-line">1.000.000</span> gebruikers over de hele wereld'
    },
    {
        locale: "ja",
        title: '世界中の<span class="down-mark-line">1,000,000</span>人以上のユーザーに参加しよう'
    },
    {
        locale: "pt",
        title: 'Junte-se a mais de <span class="down-mark-line">1.000.000</span> usuários em todo o mundo'
    },
    {
        locale: "zh",
        title: '加入超过<span class="down-mark-line">1,000,000</span>全球用户'
    },
])

const agencies = ref([
    "PLES_grand.png",
    "anson.png",
    "blubrry.png",
    "jacob.png",
    "marketing-difference.png",
    "rosbeef.png",
    "adplorer.png",
    "aw.png",
    "gardner-literary.png",
    "lindwood.png",
    "romance.png",
    "triton.png",
],)

const [emblaNode] = EmblaCarousel({ loop: false, dragFree: true, align: 'start' })

</script>
<style scoped>
.embla {
    --slide-spacing: 1.2rem;
    --slide-size: 20%;
    padding: 1.6rem;
    overflow: hidden;
}

@media (max-width:1024px) {
    .embla {
        --slide-spacing: 1rem;
        --slide-size: 25%;
    }
}

@media (max-width:640px) {
    .embla {
        --slide-spacing: 1rem;
        --slide-size: 50%;
    }
}

.embla__container {
    display: flex;
    flex-direction: row;
    height: auto;
    margin-left: calc(var(--slide-spacing) * -1);
    align-items: center;
}

.embla__slide {
    flex: 0 0 var(--slide-size);
    min-width: 0;
    padding-left: var(--slide-spacing);
    position: relative;
}
</style>